var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillPaymentSuccess = function SvgBillPaymentSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 500,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466.244 162.874C370.983 55.352 145.455 49.343 79.141 134.624c-36.539 46.988-21.269 117.231-13.736 151.888 13.864 63.777 48.05 104.836 55.514 113.546 18.113 21.134 62.11 72.466 128.308 84.199 113.108 20.049 254.24-82.031 262.06-197.2 4.507-66.398-36.807-114.887-45.043-124.183Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.836 500c143.145 0 259.186-8.472 259.186-18.922 0-10.45-116.041-18.922-259.186-18.922-143.144 0-259.186 8.472-259.186 18.922 0 10.45 116.042 18.922 259.186 18.922Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.856 486.371h-45.985v.331h45.985v-.331ZM120.077 484.559h-25.88v.331h25.88v-.331ZM247.448 483.791h-52.455v.331h52.455v-.331ZM193.659 479.08h-23.447v.331h23.447v-.331ZM459.55 481.21h-70.835v.331h70.835v-.331Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.691 465.903c3.025-11.689 5.713-29.407-.11-48.5-6.686-21.924-18.482-25.621-30.405-48.741-17.019-33.003-1.994-58.709-17.947-68.089-7.78-4.574-19.478-3.809-26.35 1.749-19.603 15.857-9.718 78.661 24.587 101.165 15.515 10.178 28.311 8.008 40.361 21.707 10.648 12.105 11.01 28.974 9.864 40.709Z",
    fill: "url(#BillPaymentSuccess_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    fill: "#fff"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m161.066 436.969.37-.12a86.97 86.97 0 0 0-5.912-13.786c-5.421-10.116-11.005-15.498-18.076-22.312-4.593-4.426-9.797-9.443-15.909-16.719-11.43-13.61-15.015-18.416-18.458-26.298-6.822-15.607-6.902-29.997-6.343-37.185.794-10.198 3.573-20.035 8.261-29.239l-.348-.173c-4.71 9.249-7.503 19.134-8.3 29.383-.562 7.224-.482 21.684 6.373 37.368 3.464 7.925 7.059 12.747 18.518 26.391 6.124 7.291 11.336 12.316 15.936 16.748 7.046 6.791 12.611 12.155 18.003 22.216a86.402 86.402 0 0 1 5.887 13.726h-.002Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m99.161 346.738-.016-.316c-.58-11.78 6.51-19.896 12.56-24.631 6.568-5.141 13.357-7.516 13.424-7.539l-.127-.364c-.069.024-6.919 2.42-13.538 7.601-6.065 4.747-13.164 12.859-12.72 24.626-1.3-.647-6.743-3.553-11.847-9.114-5.361-5.843-11.435-15.897-9.926-30.626l-.387-.039c-1.524 14.876 4.616 25.033 10.035 30.935 5.87 6.391 12.188 9.306 12.251 9.334l.291.132v.001ZM104.645 384.306c7.878-.769 13.551-3.739 13.653-3.794l.144-.078-.053-.152c-7.347-21.73 6.773-34.053 6.917-34.176l-.254-.291c-.036.031-3.675 3.164-6.339 8.968-2.447 5.328-4.553 14.064-.744 25.464-1.758.88-19.106 9.069-34.87-1.49l-.218.318c7.504 5.026 15.363 5.855 21.764 5.23v.001ZM119.862 405.532c10.656-1.04 15.784-6.159 15.857-6.235l.096-.099-.064-.122c-5.966-11.395-.03-31.079.03-31.276l-.372-.112c-.06.198-5.998 19.888-.07 31.439-1.125 1.05-11.822 10.292-33.377 4.068l-.108.37c7.173 2.071 13.162 2.441 18.007 1.968l.001-.001Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M558.898 304.741c-16.455-24.786-1.43-51.426-3.93-78.991-2.5-27.566-28.968-33.587-23.955-56.957 5.802-27.09-9.651-53.107-27.176-53.107s-32.992 26.017-27.177 53.107c5.013 23.37-21.455 29.391-23.955 56.957-2.499 27.565 12.513 54.218-3.93 78.991-16.455 24.787-12.138 57.606-2.86 73.896 2.553 4.487 5.561 8.457 8.836 11.977 26.307 28.201 71.878 28.201 98.185 0 3.275-3.52 6.283-7.49 8.836-11.977 9.277-16.29 13.595-49.123-2.86-73.896h-.014Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M504.157 323.214c4.666 0 8.461 3.99 8.461 8.894v149.756h-16.922V332.108c0-4.904 3.795-8.894 8.461-8.894Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444.399 382.402c-5.541-7.773-12.801-20.577-11.621-35.7 2.058-26.385 27.491-30.134 37.857-62.308 8.361-25.95-3.772-37.201 9.35-58.067 2.196-3.493 13.589-22.382 29.225-21.774 8.812.342 15.058 6.713 16.231 7.91 17.724 18.077 12.045 62.38-9.294 91.614-12.26 16.796-19.028 16.464-43.173 40.766-14.188 14.28-23.247 28.26-28.575 37.559Z",
    fill: "url(#BillPaymentSuccess_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    fill: "#fff"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m446.868 393.757-.331.082c-5.624-22.224-4.2-39.646 4.233-51.781 4.128-5.94 8.416-8.62 12.957-11.457 4.883-3.052 9.933-6.207 14.922-13.802 4.848-7.382 5.375-12.507 6.04-18.996.6-5.836 1.346-13.1 5.517-24.295 3.656-9.813 7.149-15.259 10.231-20.063 3.339-5.205 5.976-9.316 7.572-17.058 2.607-12.645.539-26.269-6.145-40.494l.309-.142c6.716 14.291 8.792 27.986 6.17 40.704-1.609 7.803-4.261 11.937-7.619 17.171-3.072 4.79-6.555 10.219-10.199 19.999-4.156 11.155-4.899 18.394-5.496 24.211-.672 6.534-1.201 11.696-6.094 19.146-5.029 7.657-10.111 10.833-15.026 13.904-4.51 2.819-8.771 5.481-12.859 11.363-8.374 12.052-9.781 29.381-4.183 51.506l.001.002Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m499.106 255.879-.031-.224c-.044-.327-4.587-32.738-20.684-39.33l.13-.312c8.519 3.488 13.746 14.078 16.632 22.347 2.833 8.117 4.025 15.647 4.229 17.026 15.723-7.014 24.42-18.348 28.954-26.639 4.936-9.028 6.137-16.496 6.148-16.57l.338.051c-.011.075-1.218 7.59-6.179 16.668-4.579 8.378-13.383 19.844-29.329 26.891l-.209.093.001-.001Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M511.692 279.319a76.678 76.678 0 0 1-4.56 1.837c-11.357 4.16-20.287 4.474-20.376 4.477l-.146.004-.027-.143c-3.066-16.564-16.83-35.636-16.968-35.826l.278-.197c.139.191 13.866 19.212 16.999 35.818 1.201-.06 9.619-.601 20.133-4.454 10.43-3.823 25.116-11.781 35.846-27.983l.285.185c-9.297 14.038-21.547 21.916-31.465 26.282h.001ZM514.507 320.022c-26.25 11.556-46.163 8.098-46.374 8.059l-.178-.032.042-.173c4.59-18.913-10.719-39.2-10.873-39.403l.272-.204c.156.203 15.466 20.494 10.977 39.509 2.18.339 23.97 3.242 51.374-10.606l.155.301c-1.823.922-3.624 1.77-5.394 2.549h-.001Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.823 374.183c4.267-4.843 11.416-12.08 21.778-18.671 18.431-11.722 28.63-9.701 35.146-20.088 6.743-10.752-.997-18.002 7.243-30.174.693-1.023 9.605-13.823 20.748-12.416 7.796.984 12.498 8.394 14.705 11.869 8.563 13.492 10.912 36.534-2.288 51.235-12.515 13.937-32.683 13.364-39.096 13.14-11.251-.394-14.725-3.89-26.087-3.973-13.817-.1-25.016 4.953-32.149 9.077v.001Z",
    fill: "url(#BillPaymentSuccess_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    fill: "#fff"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m410.388 378.462-.259-.22c10.357-11.961 21.565-19.064 33.284-21.111 5.128-.895 8.945-.605 12.636-.325 4.615.35 8.972.681 15.636-1.159 11.992-3.314 21.361-9.781 26.381-18.21 7.773-13.054 5.81-31.469-5.003-46.913l.28-.193c10.889 15.552 12.858 34.111 5.016 47.278-5.064 8.504-14.505 15.026-26.582 18.363-6.72 1.858-11.109 1.523-15.754 1.17-3.67-.278-7.465-.566-12.55.321-11.647 2.031-22.781 9.099-33.085 20.998v.001Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m501.448 329.594-.041-.257c-1.645-10.387-9.692-16.689-16.152-20.146-7.018-3.756-13.734-5.062-13.801-5.075l.064-.332c.067.012 6.829 1.327 13.891 5.105 6.477 3.464 14.533 9.761 16.293 20.134 2.053-1.39 17.711-12.519 15.516-26.824l.339-.051c2.369 15.443-15.705 27.187-15.887 27.304l-.222.142ZM501.743 354.014a43.015 43.015 0 0 1-6.614.797c-8.665.353-14.371-2.126-14.427-2.151l-.153-.067.065-.152c4.083-9.642.939-18.438-2.418-24.119-3.645-6.172-8.323-10.108-8.371-10.147l.221-.259c.047.039 4.764 4.006 8.44 10.226 3.381 5.719 6.55 14.561 2.509 24.274.959.386 6.333 2.378 14.138 2.057 7.928-.327 20.058-3.176 32.826-14.897l.233.248c-9.689 8.895-19.02 12.713-26.449 14.192v-.002Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M399.287 470.386h-22.644V331.791c0-6.167 5.093-11.209 11.322-11.209 6.229 0 11.322 5.042 11.322 11.209v138.595Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 433.001c38.516 0 69.739-30.91 69.739-69.04 0-38.129-31.223-69.039-69.739-69.039-38.516 0-69.739 30.91-69.739 69.039 0 38.13 31.223 69.04 69.739 69.04Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M469.901 343.245c3.659-14.583-5.316-29.342-20.048-32.965-14.731-3.622-29.639 5.263-33.299 19.847-3.659 14.583 5.317 29.342 20.048 32.965 14.731 3.622 29.64-5.263 33.299-19.847ZM347.617 323.158c1.444-8.779-4.574-17.055-13.442-18.485-8.868-1.43-17.228 4.528-18.672 13.307-1.445 8.779 4.574 17.055 13.442 18.485 8.868 1.43 17.227-4.528 18.672-13.307Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M349.253 323.546c6.305 0 11.416-5.06 11.416-11.301 0-6.242-5.111-11.302-11.416-11.302-6.305 0-11.416 5.06-11.416 11.302 0 6.241 5.111 11.301 11.416 11.301Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M244.305 387.663c-11.617 1.707-21.669 5.875-30.372 11.473-.08-10.468-2.018-20.419-6.991-28.452-7.566 7.305-13.702 16.754-18.661 26.904-1.859-19.096-6.925-37.61-18.14-49.295-16.804 10.468-25.466 27.909-29.583 46.384-6.697-11.831-15.934-22.762-28.687-30.702-10.28 10.719-13.568 25.54-13.287 40.733-11.684-13.459-24.65-23.98-37.296-25.21-3.115 21.319 3.515 41.434 11.937 57.288 11.055 20.79 33.045 33.613 56.773 33.613h54.927c23.407 0 45.357-12.36 56.332-32.832 6.951-12.956 10.266-29.657 3.048-49.891v-.013Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m41.06 78.858 307.757 134.219 30.909 54.875L41.06 78.858Z",
    fill: "#407BFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m41.06 78.858 307.757 134.219 30.909 54.875L41.06 78.858Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m41.06 78.858 307.757 134.219-32.396 58.059L41.061 78.858Z",
    fill: "#2351B6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m41.06 78.858 307.757 134.219-32.396 58.059L41.061 78.858Z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m360.505 89.498-5.713 91.509c-.306 4.958-4.65 8.755-9.658 8.453l-175.959-10.772c-5.009-.302-8.845-4.603-8.539-9.561l5.713-91.509a8.998 8.998 0 0 1 3.321-6.406 9.24 9.24 0 0 1 6.351-2.043L351.98 79.941a9.179 9.179 0 0 1 6.049 2.796c1.674 1.752 2.656 4.184 2.49 6.765l-.014-.004Z",
    fill: "#407BFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m360.505 89.498-5.713 91.509c-.306 4.958-4.65 8.755-9.658 8.453l-175.959-10.772c-5.009-.302-8.845-4.603-8.539-9.561l5.713-91.509a8.998 8.998 0 0 1 3.321-6.406 9.24 9.24 0 0 1 6.351-2.043L351.98 79.941a9.179 9.179 0 0 1 6.049 2.796c1.674 1.752 2.656 4.184 2.49 6.765l-.014-.004Z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m358.001 82.728-74.497 52.106c-14.234 9.951-33.534 8.779-46.42-2.838L169.646 71.19a9.24 9.24 0 0 1 6.351-2.043L351.956 79.92a9.179 9.179 0 0 1 6.049 2.796l-.004.013ZM41.06 78.858l246.927 135.234 28.434 57.044L41.061 78.858Z",
    fill: "#407BFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m41.06 78.858 246.927 135.234 28.434 57.044L41.061 78.858Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m41.06 78.858 246.927 135.234-68.691 47.152L41.06 78.858ZM456.979 229.388a3.197 3.197 0 0 1-.986-.482l-38.321-28.785a2.868 2.868 0 0 1-.555-4.055 2.931 2.931 0 0 1 4.096-.549l38.321 28.784a2.868 2.868 0 0 1 .555 4.055c-.746.98-1.985 1.343-3.11 1.032Z",
    fill: "#407BFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M456.979 229.388a3.197 3.197 0 0 1-.986-.482l-38.321-28.785a2.868 2.868 0 0 1-.555-4.055 2.931 2.931 0 0 1 4.096-.549l38.321 28.784a2.868 2.868 0 0 1 .555 4.055c-.746.98-1.985 1.343-3.11 1.032Z",
    fill: "#000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M461.328 204.222a3.242 3.242 0 0 1-.986-.482l-20.582-15.453a2.868 2.868 0 0 1-.555-4.055 2.932 2.932 0 0 1 4.096-.55l20.582 15.453a2.868 2.868 0 0 1 .555 4.055c-.745.98-1.985 1.343-3.11 1.032Z",
    fill: "#407BFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M461.328 204.222a3.242 3.242 0 0 1-.986-.482l-20.582-15.453a2.868 2.868 0 0 1-.555-4.055 2.932 2.932 0 0 1 4.096-.55l20.582 15.453a2.868 2.868 0 0 1 .555 4.055c-.745.98-1.985 1.343-3.11 1.032Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M406.184 214.912a3.242 3.242 0 0 1-.986-.482l-37.369-28.072a2.87 2.87 0 0 1-.556-4.055 2.937 2.937 0 0 1 4.096-.55l37.37 28.072a2.868 2.868 0 0 1 .555 4.055 2.915 2.915 0 0 1-3.11 1.032Z",
    fill: "#407BFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M406.184 214.912a3.242 3.242 0 0 1-.986-.482l-37.369-28.072a2.87 2.87 0 0 1-.556-4.055 2.937 2.937 0 0 1 4.096-.55l37.37 28.072a2.868 2.868 0 0 1 .555 4.055 2.915 2.915 0 0 1-3.11 1.032Z",
    fill: "#000"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M283.468 302.863a3.242 3.242 0 0 1-.986-.482l-38.32-28.785a2.87 2.87 0 0 1-.556-4.055 2.931 2.931 0 0 1 4.096-.55l38.321 28.785a2.87 2.87 0 0 1 .556 4.055 2.917 2.917 0 0 1-3.111 1.032Z",
    fill: "#407BFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M283.468 302.863a3.242 3.242 0 0 1-.986-.482l-38.32-28.785a2.87 2.87 0 0 1-.556-4.055 2.931 2.931 0 0 1 4.096-.55l38.321 28.785a2.87 2.87 0 0 1 .556 4.055 2.917 2.917 0 0 1-3.111 1.032Z",
    fill: "#000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M287.816 277.697a3.229 3.229 0 0 1-.985-.483l-20.583-15.453a2.87 2.87 0 0 1-.555-4.055 2.932 2.932 0 0 1 4.096-.549l20.583 15.453a2.87 2.87 0 0 1 .555 4.055c-.746.979-1.985 1.342-3.111 1.032Z",
    fill: "#407BFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287.816 277.697a3.229 3.229 0 0 1-.985-.483l-20.583-15.453a2.87 2.87 0 0 1-.555-4.055 2.932 2.932 0 0 1 4.096-.549l20.583 15.453a2.87 2.87 0 0 1 .555 4.055c-.746.979-1.985 1.342-3.111 1.032Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M232.673 288.386a3.242 3.242 0 0 1-.986-.482l-37.369-28.072a2.868 2.868 0 0 1-.555-4.055 2.937 2.937 0 0 1 4.096-.55l37.369 28.072a2.87 2.87 0 0 1 .556 4.055c-.746.98-1.986 1.343-3.111 1.032Z",
    fill: "#407BFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M232.673 288.386a3.242 3.242 0 0 1-.986-.482l-37.369-28.072a2.868 2.868 0 0 1-.555-4.055 2.937 2.937 0 0 1 4.096-.55l37.369 28.072a2.87 2.87 0 0 1 .556 4.055c-.746.98-1.986 1.343-3.111 1.032Z",
    fill: "#000"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M241.33 287.6c6.147 10.053 6.175 21.724.406 28.615-2.785 3.326-9.001 8.019-16.256 8.131-3.458.053-5.172-.965-6.394.165-3.102 2.864.727 16.07 8.016 18.809 9.479 3.562 27.639-9.52 30.463-26.239 2.685-15.899-9.658-28.222-11.219-29.733l-5.016.252Z",
    fill: "url(#BillPaymentSuccess_svg__d)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.782 328.643c.345-7.506 5.168-12.315 6.372-13.479 7.189-6.95 17.339-6.68 20.587-6.593 11.527.306 14.129 5.966 22.172 3.86 6.808-1.784 7.332-6.467 13.193-6.785 6.128-.332 12.552 4.408 15.126 9.795 4.958 10.383-2.78 26.567-13.823 31.451-11.474 5.075-17.681-5.956-38.72-2.7-7.672 1.188-12.168 3.479-17.142.698-5.448-3.046-8.041-10.262-7.765-16.247Z",
    fill: "url(#BillPaymentSuccess_svg__e)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M226.364 473.794s-.609.574-.601 1.578a.985.985 0 0 0 .389.773c.542.414 1.737 1.23 3.594 1.979 2.629 1.058 3.512.956 3.619.522.106-.433-1.25-1.601-2.413-2.622-1.164-1.02-4.588-2.228-4.588-2.228v-.002Z",
    fill: "url(#BillPaymentSuccess_svg__f)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M225.494 469.766s.863 3.92.805 5.355c0 0 1.055.909 2.538-.022 0 0-.793-3.58-.43-5.07l-2.913-.263Z",
    fill: "url(#BillPaymentSuccess_svg__g)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M197.047 475.388s-.682.484-.816 1.48a.985.985 0 0 0 .277.819c.478.485 1.549 1.457 3.284 2.452 2.454 1.407 3.345 1.427 3.51 1.012.166-.414-1.015-1.756-2.023-2.926-1.009-1.17-4.232-2.836-4.232-2.836v-.001Z",
    fill: "url(#BillPaymentSuccess_svg__h)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M195.786 471.775s.863 3.92.805 5.355c0 0 1.055.909 2.538-.022 0 0-.793-3.58-.43-5.07l-2.913-.263Z",
    fill: "url(#BillPaymentSuccess_svg__i)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M235.111 387.628c.356 11.79.298 24.441-.37 37.846a474.543 474.543 0 0 1-4.606 46.415 11.572 11.572 0 0 1-5.561.185 360.685 360.685 0 0 0-1.731-7.279c-1.39-5.579-1.721-6.322-2.157-8.239-1.809-7.953.458-10.223-.714-18.434-.257-1.8-.359-1.639-2.87-10.296-3.131-10.793-4.713-16.186-5.459-20.321-2.004-11.094-3.006-16.642.105-20.092 4.066-4.508 13.617-3.892 23.363.215Z",
    fill: "url(#BillPaymentSuccess_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M227.435 465.167c-1.335-3.649.937-5.53.871-11.841-.056-5.446-1.769-6.111-2.329-12.227-.516-5.609.725-7.216 1.006-12.394.529-9.759-3.392-12.998-4.208-20.469-.562-5.143.315-12.64 7.162-22.464-7.809-2.307-14.849-2.063-18.189 1.639-3.113 3.451-2.11 8.998-.105 20.093.747 4.134 2.328 9.528 5.459 20.32 2.511 8.656 2.613 8.496 2.87 10.297 1.172 8.21-1.095 10.482.714 18.434.436 1.917.767 2.658 2.157 8.239a339.557 339.557 0 0 1 1.731 7.279 11.554 11.554 0 0 0 5.561-.186c.129-.864.255-1.733.382-2.607-1.325-1.069-2.461-2.414-3.082-4.113Z",
    fill: "url(#BillPaymentSuccess_svg__k)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.313 386.91a463.639 463.639 0 0 0-22.07 85.641 7.656 7.656 0 0 1-6.26.092 69.778 69.778 0 0 1-4.232-14.88c-.645-3.856-1.348-8.056-.876-13.464.627-7.184 2.615-8.337 3.482-15.442.65-5.31-.255-6.352-.537-14.031-.437-11.911-.662-18.05 2.311-22.313 6.387-9.157 25.083-6.139 28.181-5.605l.001.002Z",
    fill: "url(#BillPaymentSuccess_svg__l)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.296 388.761c-1.404-7.848-.258-7.462-1.575-16.525-1.726-11.867-3.878-13.831-4.903-22.166-.607-4.928-.851-12.329 1.426-21.781-2.586-1.449-11.518-6.036-23.332-4.203a35.936 35.936 0 0 0-4.243.924c-1.219-.735-2.908.153-6.1.158-7.257.01-13.551-4.577-16.393-7.857-5.887-6.792-6.06-18.461-.086-28.616l-5.02-.169c-1.083 1.098-15.324 15.9-10.705 29.917 2.62 7.949 10.781 14.06 11.345 14.474 5.231 3.838 8.363 3.614 13.625 8.878 1.485 1.484 3.516 3.782 4.791 4.237 4.847 8.382 4.784 13.484 3.206 16.752-1.592 3.295-4.569 4.41-7.732 10.897-3.139 6.436-1.807 8.616-4.642 11.445-5.085 5.075-12.849 1.532-14.521 5.007-1.642 3.413 4.209 10.24 10.143 13.65 4.698 2.699 9.227 3.128 12.415 3.397 5.79.489 6.734-.738 16.445-1.552 7.273-.609 11.385-.954 16.865-.187 7.588 1.062 9.998 3.162 11.812 1.652 2.384-1.985-.796-7.039-2.818-18.334l-.003.002Z",
    fill: "url(#BillPaymentSuccess_svg__m)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M210.844 315.756c.376 1 .883 3.212-.191 5.218-.941 1.758-2.71 2.541-3.417 2.861-1.71.777-2.744.557-2.787.879-.096.711 4.814 2.961 9.866 1.912 2.969-.616 5.771-2.328 5.575-3.272-.219-1.061-4.032-.29-5.367-2.337-.853-1.307-.315-3.187.362-4.695-.989-.81-3.05.246-4.041-.566Z",
    fill: "url(#BillPaymentSuccess_svg__n)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M211.438 319.087s2.243 1.597 4.586.212c2.092-1.239-.083-6.755-1.994-7.205-.638-.149-1.637.153-2.282.758-.38.358-.437.636-1.071 1.208-.586.529-.815.541-.931.831-.146.364-.063 1.036 1.092 2.394-.63-.256-1.211-.185-1.479.174a.916.916 0 0 0-.145.456c-.019.766.854 1.296 2.225 1.172h-.001Z",
    fill: "url(#BillPaymentSuccess_svg__o)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.789 395.412c4.206-8.391 14.87-9.212 15.347-15.896.35-4.889-5.278-5.552-7.513-12.595-3.362-10.59 6.725-17.4 3.154-24.676-2.44-4.97-7.738-3.002-20.054-9.38-5.748-2.976-14.873-7.703-20.12-17.152-2.135-3.843-3.206-7.713-3.699-11.181-1.509 4.355-2.101 9.179-.541 13.913 2.619 7.949 10.78 14.059 11.345 14.473 5.231 3.838 8.362 3.614 13.625 8.878 1.484 1.485 3.516 3.783 4.791 4.237 4.846 8.383 4.783 13.484 3.205 16.752-1.592 3.296-4.569 4.411-7.732 10.898-3.138 6.435-1.807 8.615-4.641 11.445-5.086 5.074-12.85 1.532-14.522 5.007-1.642 3.413 4.209 10.239 10.143 13.649 4.698 2.699 9.228 3.129 12.415 3.398 1.461.123 2.613.136 3.676.076-1.051-5.323-.253-9.106 1.121-11.848v.002Z",
    fill: "url(#BillPaymentSuccess_svg__p)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M180.621 288.622c.141.005 1.303-2.592-.034-3.811-1.336-1.219-5.579-3.318-6.071-3.936-.493-.617.845 3.827 2.805 4.959 1.961 1.134 1.971 2.742 1.971 2.742l1.327.045.002.001Z",
    fill: "url(#BillPaymentSuccess_svg__q)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M242.807 287.552s-.637-1.6.525-2.777 3.918-1.444 4.315-3.611c.395-2.168 1.535 2.014.234 3.171-1.3 1.157-3.147 3.119-3.147 3.119l-1.927.098Z",
    fill: "url(#BillPaymentSuccess_svg__r)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M340.038 284.776c.131-.138 3.376-.919 3.376-.919s.965-3.557 2.849-1.735c1.886 1.822 1.929 4.252.438 4.338-1.49.087-4.471-.43-5.919.305-1.447.737-.746-1.99-.746-1.99l.002.001Z",
    fill: "url(#BillPaymentSuccess_svg__s)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m383.692 243.25-3.031-2.651a2.573 2.573 0 0 1-.88-2.035c.043-1.129-.023-2.781-.664-3.648-1.034-1.398-4.919-.26-5.094 0-.764 1.135-1.037 3.095 1.266 3.82 2.302.724 2.892 1.926 2.892 1.926l3.642 5.092 1.871-2.504h-.002Z",
    fill: "url(#BillPaymentSuccess_svg__t)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M368.935 478.509c.294-.878 3.351-1.283 4.635.129.637.7.962 1.985.466 2.475-.181.179.392.617-.206.54-1.985-.255-5.188-2.273-4.895-3.144Z",
    fill: "url(#BillPaymentSuccess_svg__u)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M371.97 479.267h3.085c-1.163-1.866-.144-7.148-.144-7.148l-3.318.261s.158 1.512.473 3.75c.109.767.038 1.935-.096 3.135v.002Z",
    fill: "url(#BillPaymentSuccess_svg__v)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M363.974 363.807a139.945 139.945 0 0 0-4.784 21.667c-3.748 26.978 4.217 27.839 2.73 57.732-.475 9.543 8.354 31.547 9.133 32.032.376.036.785.06 1.221.047.767-.023 1.85-.14 3.109-.513 1.399-.238 6.441-13.753 5.273-21.788-1.408-9.682.321-16.405-.108-23.998-1.027-18.177-.064-37.38 1.218-37.451.811-.046 2.152 7.547 3.562 15.525 1.617 9.16 1.879 13.345 5.309 17.34 2.316 2.696 5.086 4.15 7.011 4.947 23.372 9.668 20.119 9.736 25.217 13.905.844.691 3.131 2.633 4.739 1.928 1.079-.473 1.396-1.934 1.531-2.595 1.066-5.246-2.216-16.185-10.89-20.288-3.107-1.47-3.975-.693-6.975-2.525-3.726-2.277-6.389-5.992-7.533-9.436-2.014-6.064 1.149-9.85 2.886-17.901.334-1.545-.17-15.349-1.674-24.465-1.967-11.913-40.97-4.161-40.97-4.161l-.005-.002Z",
    fill: "url(#BillPaymentSuccess_svg__w)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M371.756 478.861s3.761-.322 4.052.448c.291.77.324 2.727-1.978 2.342-2.302-.385-2.367-2.213-2.074-2.79Z",
    fill: "url(#BillPaymentSuccess_svg__x)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m340.981 283.8.979 3.057c-2.359 1.789-8.851 7.126-8.073 12.852 1.125 8.274 16.711 12.028 26.584 12.008 2.706-.005 20.281-.041 28.536-12.519 7.251-10.963 2.76-24.648-.944-35.936a75.498 75.498 0 0 0-9.678-19.418l4.907-4.123c5.931 3.555 17 11.388 24.149 25.455 6.59 12.968 6.968 25.569 6.899 30.356-.087 5.93-.976 7.56-1.124 16.139-.138 7.918.51 12.849 1.496 22.059 3.465 32.363 2.617 38.16.08 43.92-2.139 4.853-3.981 9.034-8.46 11.547-8.96 5.025-16.461-3.36-35.989-1.816-6.79.537-9.198 1.813-11.986-.119-1.639-1.137-4.656-4.248-3.675-24.417.838-17.232 3.37-21.807-.262-26.755-3.186-4.338-6.46-2.627-16.274-7.532-6.42-3.209-20.294-10.144-21.525-21.56-.892-8.267 5.289-14.779 6.3-15.845 7.085-7.467 16.541-7.388 18.063-7.352l-.003-.001Z",
    fill: "url(#BillPaymentSuccess_svg__y)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M376.08 300.607c-.115-2.151 1.312-3.803 1.625-4.158 1.31-1.485 1.599-1.662 2.106-1.858l.699-.238.079-.011c.426-.051 1.779.207 2.038.325.827.376.959 4.086-.428 8.983-.006.197-.015.395-.024.594-.016.294-.023.52-.031.711-.032.865.742 1.544 1.607 1.414 4.438-.67 3.823.388 3.673.728-.355.795-4.463 3.039-9.41 4.244-6.139 1.416-9.999 1.247-9.48.32.196-.35 3.241-1.922 6.843-3.1a2.67 2.67 0 0 0 1.718-1.689c.356-1.087 1.045-2.593 1.209-3.048-.311-.258-2.139-1.631-2.223-3.215l-.001-.002Z",
    fill: "url(#BillPaymentSuccess_svg__z)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M379.029 292.546c-.343 1.536.017 3.338.329 3.684.04.045.264.316.425.732a.827.827 0 0 1 .047.201c.121 1.043-1.691 1.836-1.49 2.336.147.363 1.297.178 1.362.476.061.282-.938.616-.872.951.049.253.637.162.898.591.13.214.049.342.105.922.032.327.1.692.169.901.332 1.021 1.775 1.688 2.149 1.39.104-.081.054-.181.213-.501 0 0 .147-.296.45-.608.431-.447 1.273-.647 2.162-1.023 1.645-.696 2.225-1.471 2.406-1.736.064-.094.107-.167.139-.22.625-1.05 1.004-2.712.72-3.847-.473-1.904-2.599-1.522-3.805-3.571-1.391-2.365.308-4.798-.62-5.315-1.023-.57-4.154 1.793-4.787 4.634v.003Z",
    fill: "#26264F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M378.978 299.261c.498-.432 1.055.202.908.872-.147.67-.96 1.22-1.565.947s-.011-1.235.658-1.817l-.001-.002Z",
    fill: "url(#BillPaymentSuccess_svg__A)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m426.762 444.381 1.958 1.545 1.32-1.417-1.799-1.73a.987.987 0 0 0-1.296-.058l-.19.152a.962.962 0 0 0 .006 1.507l.001.001Z",
    fill: "url(#BillPaymentSuccess_svg__B)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M430.424 447.105c.048-1.429.761-1.86.423-2.552-.265-.545-1.005-.89-1.61-.767-.85.171-1.209 1.22-1.29 1.456-.551 1.61.663 2.507-.011 3.832-.136.267-.392.639-.485 1.249-.04.26-.138.904.142 1.077.325.198.988-.335 1.621-.843.758-.61 1.138-.914 1.325-1.43.26-.714-.15-.918-.115-2.02v-.002Z",
    fill: "url(#BillPaymentSuccess_svg__C)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M389.969 369.413c-7.757-3.44-16.291 4.615-18.864 1.905-2.927-3.082 8.855-12.703 7.699-25.906-.674-7.702-5.789-17.033-13.474-19.81-8.011-2.894-14.293 2.968-20.79-1.523-3.482-2.408-2.187-4.445-6.159-8.381-6.801-6.74-14.102-4.246-18.094-8.764-1.434-1.623-2.529-4.253-2.125-8.785-1.124 2.51-1.902 5.539-1.545 8.849 1.231 11.416 15.105 18.351 21.525 21.56 9.814 4.905 13.089 3.194 16.274 7.532 3.633 4.948 1.1 9.523.262 26.755-.981 20.169 2.034 23.28 3.675 24.417 2.788 1.932 5.196.656 11.986.119 19.528-1.543 27.029 6.841 35.989 1.816a13.733 13.733 0 0 0 3.848-3.204c-4.997-.04-8.136-1.445-10.198-3.247-4.767-4.166-4.111-10.719-10.009-13.333Z",
    fill: "url(#BillPaymentSuccess_svg__D)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__a",
    x1: 152.072,
    y1: 337.271,
    x2: 116.577,
    y2: 395.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__b",
    x1: 514.858,
    y1: 232.966,
    x2: 446.714,
    y2: 371.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__c",
    x1: 520.013,
    y1: 314.213,
    x2: 368.149,
    y2: 408.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__d",
    x1: 243.407,
    y1: 312.985,
    x2: 82.546,
    y2: 517.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__e",
    x1: 160.233,
    y1: 393.657,
    x2: 193.868,
    y2: 305.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__f",
    x1: 225.789,
    y1: 476.387,
    x2: 233.368,
    y2: 476.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__g",
    x1: 228.579,
    y1: 479.795,
    x2: 226.568,
    y2: 467.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__h",
    x1: 196.255,
    y1: 478.402,
    x2: 203.314,
    y2: 478.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__i",
    x1: 197.636,
    y1: 480.303,
    x2: 197.336,
    y2: 468.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__j",
    x1: 213.849,
    y1: 485.697,
    x2: 222.219,
    y2: 412.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__k",
    x1: 213.768,
    y1: 485.688,
    x2: 222.138,
    y2: 412.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__l",
    x1: 182.301,
    y1: 413.782,
    x2: 216.697,
    y2: 435.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__m",
    x1: 239.776,
    y1: 310.13,
    x2: 78.915,
    y2: 514.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__n",
    x1: 220.251,
    y1: 308.627,
    x2: 209.153,
    y2: 330.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__o",
    x1: 234.543,
    y1: 318.418,
    x2: 220.431,
    y2: 316.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__p",
    x1: 202.287,
    y1: 307.027,
    x2: 85.459,
    y2: 716.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__q",
    x1: 181.607,
    y1: 299.989,
    x2: 178.949,
    y2: 288.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__r",
    x1: 247.903,
    y1: 294.53,
    x2: 246.114,
    y2: 286.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__s",
    x1: 359.061,
    y1: 284.831,
    x2: 576.458,
    y2: 292.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__t",
    x1: 357.08,
    y1: 239.189,
    x2: 535.151,
    y2: 245.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__u",
    x1: 367.674,
    y1: 475.679,
    x2: 373.487,
    y2: 480.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__v",
    x1: 373.324,
    y1: 480.854,
    x2: 373.324,
    y2: 470.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__w",
    x1: 375.689,
    y1: 486.19,
    x2: 413.203,
    y2: 333.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__x",
    x1: 368.265,
    y1: 475.022,
    x2: 374.077,
    y2: 480.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__y",
    x1: 316.53,
    y1: 315.27,
    x2: 417.011,
    y2: 315.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__z",
    x1: 354.758,
    y1: 302.611,
    x2: 532.83,
    y2: 309.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__A",
    x1: 354.881,
    y1: 299.272,
    x2: 532.951,
    y2: 305.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__B",
    x1: 432.091,
    y1: 449.005,
    x2: 409.932,
    y2: 421.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__C",
    x1: 430.739,
    y1: 451.806,
    x2: 422.15,
    y2: 430.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BillPaymentSuccess_svg__D",
    x1: 316.53,
    y1: 344.483,
    x2: 410.177,
    y2: 344.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })))));
};
export default SvgBillPaymentSuccess;